import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';

const CookiesView = () => {
    return (
        <>
            <section className="section">
                <div className="container container--small">
                    <div className="content--container">
                        <h1>Cookie statement</h1>
                        <p>
                            Op deze website worden cookies gebruikt. Een cookie
                            is een klein stukje informatie dat in de vorm van
                            een bestand op uw computer of mobiele apparaat wordt
                            opgeslagen. Hierdoor wordt uw computer of mobiele
                            apparaat herkend bij een volgend bezoek. Met cookies
                            worden ook technieken bedoeld die vergelijkbaar zijn
                            met cookies. Bijvoorbeeld JavaScript, tags, web
                            beacons, pixels en HTML5 Local Storage. Op deze
                            pagina leest u welke cookies worden geplaatst. En
                            wat dat voor uw privacy betekent.
                        </p>
                        <h2>De cookies</h2>
                        <p>
                            Op deze website worden uitsluitend functionele en
                            beperkt analytische cookies geplaatst. Hiervoor is
                            uw toestemming niet nodig.
                        </p>
                        <p>
                            <strong>
                                Functionele cookies
                                <br />
                            </strong>
                            Deze cookies zorgen er bijvoorbeeld voor dat de
                            website technisch goed werkt of beveiligd is.&nbsp;
                        </p>

                        <u>Cookie: Interpolis</u>
                        <ul>
                            <li>
                                Doel: veilige correcte werking van de website
                            </li>
                            <li>Opgeslagen gegevens: n.v.t.</li>
                            <li>Geldigheid cookies: 2 jaar</li>
                            <li>Bewaartermijn: n.v.t.</li>
                            <li>
                                Gegevens worden buiten de EER opgeslagen? n.v.t.
                            </li>
                        </ul>

                        <p>
                            <strong>
                                Beperkt analytische cookies
                                <br />
                            </strong>
                            Deze cookies worden gebruikt om statistieken te
                            verzamelen over bijvoorbeeld het gebruik van de
                            website. En om de website te verbeteren en meer
                            gebruiksvriendelijk te maken.
                        </p>

                        <u>Cookie: Google Analytics</u>
                        <ul>
                            <li>
                                <strong></strong>Doel: het vastleggen van het
                                surfgedrag van de bezoekers van Slotentool.nl
                                voor de gebruiksvriendelijkheid van de website
                            </li>
                            <li>
                                Opgeslagen gegevens: anonieme webstatistieken
                            </li>
                            <li>Geldigheid cookies: 2 jaar</li>
                            <li>Bewaartermijn: 26 maanden</li>
                            <li>
                                Gegevens worden buiten de EER opgeslagen? ja,
                                voor het gebruik van deze cookie is een
                                verwerkersovereenkomst met Google gesloten
                            </li>
                        </ul>
                        
                        <u>Cookie:&nbsp;Harvest Consent Monitor</u>
                        <ul>
                            
                            <li>
                                Doel: het monitoren en beoordelen van alle
                                geplaatste cookies en netwerkverzoeken om
                                uiteindelijk ongeldige cookies en ongeldige
                                netwerk verzoeken uit te kunnen filteren en te
                                kunnen blokkeren
                            </li>
                            <li>
                                Opgeslagen gegevens: uw gekozen cookieniveau, de
                                daarbij passende cookies die worden geplaatst en
                                de netwerkverzoeken die hierbij horen
                            </li>
                            <li>Geldigheid cookies: 2 jaar</li>
                            <li>Bewaartermijn: 90 dagen</li>
                            <li>
                                Gegevens worden buiten de EER opgeslagen: nee
                            </li>
                        </ul>

                        <h2>Wijziging van dit cookie statement</h2>
                        <p>
                            Interpolis mag dit cookie statement aanpassen als er
                            ontwikkelingen zijn in het bedrijf of als wetten of
                            regels veranderen. Dit cookie statement is voor het
                            laatst veranderd op 22 april 2026. Op deze website
                            vindt u altijd de laatste versie. Kijk daarom
                            regelmatig op de website.
                        </p>
                        <p>
                            Slotentool is een product van Interpolis. Interpolis
                            is onderdeel van Achmea Groep.
                        </p>
                    </div>
                </div>
            </section>
            <Footer flatten />
        </>
    );
};

export default CookiesView;
